import type { GetApiV1ThreeLetterCodePartnerAdminsGroupsId200 } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date/formatDate';
import { GroupDetailPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof GroupDetailPresentation>;

/**
 * GroupDetailPresentation に渡す props へ変換する際の引数オブジェクト
 */
type Args = {
  /** グループ詳細 API のレスポンスデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsGroupsId200;
};

type IConvertToPresentationProps = (args: Args) => Omit<PresentationProps, 'editLink'>;

/**
 * APIレスポンスをPresentationコンポーネントのpropsに変換する
 *
 * @param args.data - グループ詳細APIのレスポンスデータ
 * @returns groupDetail - Presentation用に整形されたグループ詳細情報
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => ({
  groupDetail: {
    name: data.group.name,
    code: data.group.code,
    description: data.group.description || '-',
    createdAt: formatDate({
      date: new Date(data.group.created_at * 1000),
      formatType: 'yyyy/MM/dd H:mm',
    }),
    updatedAt: formatDate({
      date: new Date(data.group.updated_at * 1000),
      formatType: 'yyyy/MM/dd H:mm',
    }),
  },
});
